import React from "react";
import {
  SPLIT_CONTENT_MAX_WIDTH,
  SPLIT_CONTENT_SECTION_MAX_WIDTH
} from "utils/constants/ui";

const QRCodeEditorLoader = () => (
  <div
    className="flex flex-column flex-column-m flex-row-ns w-100 center z-1 items-center items-center-m items-start-ns justify-between-ns"
    style={{ maxWidth: SPLIT_CONTENT_MAX_WIDTH }}
  >
    <div
      style={{ maxWidth: SPLIT_CONTENT_SECTION_MAX_WIDTH }}
      className="flex flex-column w-100 w-50-ns pl0-m pl3-ns z-1"
    >
      <div className="flex flex-column ba pa3 br2 hairline-1">
        <div className="flex flex-row justify-between">
          <div className="flex shimmer h2 w-20"></div>
          <div className="flex shimmer h2 w2"></div>
        </div>
        <div className="pt2 w-100">
          <div className="shimmer h2 w-90"></div>
        </div>
      </div>
      <div className="pt3">
        <div className="flex flex-column ba pa3 br2 hairline-1 h5 w-100">
          <div className="w-100 h-100 shimmer"></div>
        </div>
      </div>
      <div className="flex flex-column pa3">
        <div style={{ height: 40 }} className="w-100 h-100 shimmer"></div>
      </div>
    </div>
    <div
      style={{ maxWidth: SPLIT_CONTENT_SECTION_MAX_WIDTH }}
      className="w-100 w-50-ns flex flex-column pr0-m pr3-ns z-1"
    >
      <div className="flex flex-column">
        <div className="flex flex-row justify-between">
          <div className="flex shimmer h2 w-20"></div>
          <div className="flex shimmer h2 w3"></div>
        </div>
        <div className="flex flex-row justify-between pt3">
          <div className="flex shimmer h2 w-30"></div>
          <div className="flex shimmer h2 w-50"></div>
        </div>
      </div>
      <div className="flex flex-column pt3 mt3 bt hairline-1">
        <div className="flex flex-row justify-between">
          <div className="flex shimmer h2 w-20"></div>
          <div className="flex shimmer h2 w3"></div>
        </div>
        <div className="flex flex-row justify-between pt3">
          <div className="flex shimmer h2 w-30"></div>
          <div className="flex shimmer h2 w-50"></div>
        </div>
      </div>
      <div className="flex flex-column pt3 mt3 bt hairline-1">
        <div className="flex flex-row justify-between">
          <div className="flex shimmer h2 w-20"></div>
          <div className="flex shimmer h2 w3"></div>
        </div>
        <div className="flex flex-row justify-between pt3">
          <div className="flex shimmer h2 w-30"></div>
          <div className="flex shimmer h2 w-50"></div>
        </div>
      </div>
      <div className="flex flex-column pt3 mt3 bt hairline-1">
        <div className="flex flex-row justify-between">
          <div className="flex shimmer h2 w-20"></div>
          <div className="flex shimmer h2 w3"></div>
        </div>
        <div className="flex flex-row justify-between pt3">
          <div className="flex shimmer h2 w-30"></div>
          <div className="flex shimmer h2 w-50"></div>
        </div>
      </div>
    </div>
  </div>
);

export default QRCodeEditorLoader;
